<template>
  <div class="questions-content">
    <recent-results :results="recentResults" v-if="!state.selectedResult" />
    <choose-topic :topics="topics" v-if="state.selectedResult && !state.selectedTopic" />
    <questions-form :form-id="formId" v-if="state.selectedTopic">
      <slot name="form" />
    </questions-form>
  </div>
</template>

<script>
import RecentResults from './RecentResults'
import ChooseTopic from './ChooseTopic'
import QuestionsForm from './QuestionsForm'
import store from './store'

export default {
  name: 'Questions',
  data() {
    return {
      state: store.state
    }
  },
  props: {
    recentResults: {
      type: Array,
      default: []
    },
    topics: {
      type: Array,
      default: []
    },
    formId: {
      type: String,
      default: ''
    }
  },
  components: {
    RecentResults,
    ChooseTopic,
    QuestionsForm,
  },
  methods: {
    setSelectedResult(result) {
      store.setSelectedResult(result)
    },
    resetSelectedResult() {
      store.resetSelectedResult()
    },
    setSelectedTopic(topic) {
      store.setSelectedTopic(topic)
    },
    resetSelectedTopic() {
      store.resetSelectedTopic()
    }
  },
  mounted() {
    store.setTopics(this.topics)
    store.setRecentResults(this.recentResults)
  }
}
</script>

<style lang="scss" scoped>
  .questions-content {
    margin: calc(var(--spacing-l)*2) 0;
  }
</style>
